import React from 'react';
import Box from '@material-ui/core/Box';
import { CHILDREN_PROPTYPES } from 'bento-ordering/base/constants/propTypes';
import { MAX_GRID_WIDTH } from 'bento-ordering/base/constants/maxWidth';

const GridContainer = ({ children, ...props }) => (
  <Box {...props} maxWidth={MAX_GRID_WIDTH} margin="0 auto" width="100%">
    {children}
  </Box>
);

GridContainer.propTypes = {
  children: CHILDREN_PROPTYPES
};

export default GridContainer;
